import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isEqual } from "lodash";

import 'react-tabs/style/react-tabs.css';

import * as PD from '../classes/pdStyle';
import {getParam} from '../utils/utils';

import Buffering from "../components/Buffering";
import ViewMetadata from "../components/ViewMetadata";
import ViewCodeList from "../components/ViewCodeList";
import ListItems from "../components/ListItems";
import TreeCodeList from "../components/TreeCodeList";

import dsd from "../classes/clsDSD";

import { DesignerLayoutContext } from '../contexts/DesignerLayoutContext';

import {getCodeList, addCodeList, editCodeList} from '../utils/utilsCodeList';

import Version from "../components/Version";
import ListVersions from "../components/ListVersions";
import ViewVersion from "../components/ViewVersion";
import {zipCodeList} from "../utils/utilsCodeList";
import { assetsCodeListVersion } from "../utils/utilsCodeList";

import { Reply } from "react-bootstrap-icons";

import Rendition from '../components/Rendition';


class CodeList extends React.Component {

    static contextType = DesignerLayoutContext;

    constructor(props) {
        super(props);
        this.state = {
            mode: 'view',
            renderState: null,
            isLoaded: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleMode = this.handleMode.bind(this);
        this.handleButton = this.handleButton.bind(this);
        this.loadedItems = this.loadedItems.bind(this);
        this.loadedTree = this.loadedTree.bind(this);
        this.handleItemFilters = this.handleItemFilters.bind(this);

        this.handleExport = this.handleExport.bind(this);

        this.handleAddVersion = this.handleAddVersion.bind(this);
        this.VersionOnActioned = this.VersionOnActioned.bind(this);
        this.loadedVersions = this.loadedVersions.bind(this);



        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.FallBackNavigation = `/codelists`;
    }

    componentDidMount(){
        this.setup();
    }

    componentDidUpdate(prevProps){
        if (!isEqual(this.props, prevProps)){
            this.setup();
        }
    }

    loadCodeList(id){

        if (!id) { return; }

        this.setState({ renderState: 'loading' });

        const onLoad = function(data){
            let StateChange = {};
            StateChange.CodeList = data;
            StateChange.FormData = data;
            StateChange.renderState = 'loaded';
            StateChange.isLoaded = true;

            StateChange.OfferEdit = false;
            if (this.dsd.loggedon){
                if (this.dsd.user.id === data.idUser){
                    StateChange.OfferEdit = true;
                }
            }

            if (!StateChange.OfferEdit){
                switch (this.state.mode){
                    case 'edit':
                    case 'remove':
                        StateChange.renderState = 'denied';
                        StateChange.errorMessage = 'You cannot edit this Code List';
                        break;
                }
            }

            this.setState(StateChange, () => {
                this.setLayoutContent();
            });
        }.bind(this);

        const onFail = function(e){
            let StateChange = {};
            StateChange.renderState = 'failed';
            StateChange.errorMessage = e.message;
            if (e.response && e.response.status === 403){
                StateChange.renderState = 'denied';
                StateChange.errorMessage = 'Access Denied';
            }
            this.setState(StateChange);
        }.bind(this);

        getCodeList(this.dsd, id, onLoad, onFail);
    }

    async loadVersionAssets(id, idVersion){

        if (!id || idVersion == null){
            return;
        }

        this.setState({ renderState: 'loading' });

        const assets = await assetsCodeListVersion(this.dsd, id, idVersion);

        this.setState({
            mdVersionPage: assets["page.md"],
            VersionAssets: assets,
            isLoaded: true,
            renderState: 'loaded'
        });

        return;
        
    };



    setup(){

        let StateChange = {
            mode: 'view',
            idCodeList: null,
            CodeList: null,
            isLoaded: false,
            isUpdated: false,
            isFailed: false,
            errorMessage: null,
            renderState: null,
            FormData: {},
            OfferEdit: false,
            countItems: null,
            countTree: null,
            countVersions: null,

            idVersion: null,

            ItemFilters: {
                status: 'in use',
                search: ''
            },        };

        if (getParam('mode', this.props)){
            StateChange.mode = getParam('mode', this.props);
        }

        StateChange.idCodeList = getParam('id', this.props);
        if (!StateChange.idCodeList){
            StateChange.idCodeList = getParam('idCodeList', this.props);
        }

        if (StateChange.mode === 'new'){
            StateChange.renderState = 'loaded';
        }

        StateChange.idVersion = getParam('idVersion', this.props);


        this.setState(StateChange, async () => {

           if (this.state.idVersion){
               await this.loadVersionAssets(this.state.idCodeList, this.state.idVersion);
               if (this.context.hasLayout){
                   this.context.Layout.setLeftAsCodeListVersions(this.state.idCodeList);
               }
               return;
           }

            if (this.state.idCodeList){
                this.loadCodeList(this.state.idCodeList);
            }

       });

    }

    handleChange(event) {

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let FormData = this.state.FormData;
        FormData[FormFieldName] = FormFieldValue;
        this.setState({"FormData": FormData});
    };

    handleSubmit(event) {

        window.scrollTo(0, 0);

        switch (event.target.name){
            case 'btnCancel':
                switch (this.state.mode){
                    case 'new':
                        this.props.navigation(this.FallBackNavigation);
                        break;
                    case 'edit':
                        this.props.navigation(`/codelist/${this.state.idCodeList}`);
                        break;
                    default:
                        break;
                };
                break;
            case 'btnSave':
            default:

                this.setState({ isUpdated: false, isFailed: false, renderState: 'updating' });

                const onError = function(e){
                    this.setState({
                        isFailed: true,
                        renderState: 'error',
                        errorMessage: e.message || 'Failed to save Code List'
                    });
                }.bind(this);

                switch (this.state.mode){
                    case 'new':
                        const onAdd = function(id){
                            this.props.navigation(`/codelist/${id}`);
                        }.bind(this);
                        addCodeList(this.dsd, this.state.FormData, onAdd, onError);
                        break;
                    case 'edit':
                        const onUpdate = function(){
                            this.props.navigation(`/codelist/${this.state.idCodeList}`);
                        }.bind(this);
                        editCodeList(this.dsd, this.state.idCodeList, this.state.FormData, onUpdate, onError);
                        break;
                    default:
                        break;
                };
        };

        event.preventDefault();
    }

    handleMode(event) {
        this.setState({mode: event.target.value});
        event.preventDefault();
    }

    handleButton(event) {
        switch (event.target.name) {
            case 'btnAddItem':
                this.props.navigation(`/codelist/${this.state.idCodeList}/item?mode=new`, {state:{fallbackpath:this.props.location.pathname}});
                break;
            default:
                break;
        }
        event.preventDefault();
    }

    handleAddVersion(event) {
        this.setState({newVersion:true});
    }



    loadedItems(count) {
        this.setState({ countItems: count || 0 });
    }

    handleItemFilters(event) {

        if (this.idFilterTimeout) {
            clearTimeout(this.idFilterTimeout);
        }

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox") {
            FormFieldValue = event.target.checked;
        }

        const Filters = {
            ...this.state.ItemFilters,
            [FormFieldName]: FormFieldValue
        };

        const setFilters = () => {
            this.setState((prevState) => {
                if (isEqual(prevState.ItemFilters, Filters)) {
                    return null;
                }

                return {
                    ItemFilters: Filters,
                    countItems: null
                };
            });
        };

        switch (FormFieldName) {
            case 'search':
                this.idFilterTimeout = setTimeout(setFilters, 500);
                return;
        }

        setFilters();

        return;

    };


    versions(){

        if (!this.state.isLoaded){
            return null;
        }

        if (!this.state.CodeList){
            return null;
        }

        let newVersion = false;
        let showAdd = false;

        if (this.state.OfferEdit){
            showAdd = true;
        }
        if (this.state.newVersion){
            showAdd = false;
            newVersion = true;
        }

        return (
            <div>
                {showAdd &&
                    <div style={{display:"flex"}}>
                        <PD.Button name='btnAdd' value='add a Named Version' onClick={this.handleAddVersion}/>
                    </div>
                }
                
                {newVersion &&
                    <Version mode='new' idAbout={this.state.idCodeList} type='codelist' onActioned={this.VersionOnActioned}/>
                }
                <ListVersions key={this.state.updateToggle} OfferEdit={this.state.OfferEdit} filters={{idAbout:this.state.idCodeList}} onLoad={this.loadedVersions}/>

            </div>
        )
    }

    VersionOnActioned(){
       this.setState(
        {
            newVersion:false,
            updateToggle: Number(!this.state.updateToggle)
        })
    }

    loadedVersions(count){

        let StateChange = {};

        StateChange.countVersions = 0;
        if (count){
            StateChange.countVersions = count;
        }

        this.setState(StateChange);

    }


    loadedTree(count) {
        this.setState({ countTree: count || 0 });
    }

    setLayoutContent(){

        if (this.context.hasLayout){
            if (this.state.CodeList){
                this.context.Layout.setLeftAsCodeList(this.state.CodeList._id);
            } else {
                let Content = {Index:{}};
                this.context.Layout.setLayoutContent(Content);
                localStorage.setItem("dsdContent", JSON.stringify(Content));
            }
        }
    }


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let idCodeList = this.state.idCodeList;
            let idVersion = this.state.idVersion;
            let zipData = null;
            let link = null;

            zipData = await zipCodeList(this.dsd, idCodeList, idVersion);

            link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `codelist_${idCodeList}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }
    }

    render() {

        switch (this.state.renderState){
            case 'invalid':
            case 'failed':
            case 'denied':
                let Message = 'An error has occured';
                if (this.state.errorMessage){
                    Message = this.state.errorMessage;
                }
                return <PD.ErrorBox>{Message}</PD.ErrorBox>;
            case 'loading':
                return <Buffering/>;
        }

        if (this.state.idVersion){
            return(
                <div>
                    <PD.Button onClick={ () => this.props.navigation(`/codelist/${this.state.idCodeList}`) } value="back"><Reply/></PD.Button>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                    <ViewVersion mdPage={this.state.mdVersionPage} assets={this.state.VersionAssets} idVersion={this.state.idVersion}/>
                </div>
            )
        }

        switch (this.state.mode){
            case 'new':
            case 'edit':

                switch (this.state.renderState){
                    case 'loaded':
                    case 'updating':
                    case 'error':
                        return (
                            <div>
                                <PD.Heading>{this.state.mode} Code List</PD.Heading>

                                {this.state.renderState === 'error' &&
                                    <PD.ErrorBox>ERROR - Failed to Update</PD.ErrorBox>
                                }

                                <form>
                                    <PD.Input label="Name" width="60" name="name" value={this.state.FormData.name} onChange={this.handleChange}/>

                                    <PD.Editor label='Description' name="description" value={this.state.FormData.description} onChange={this.handleChange}/>

                                    <PD.Input label="Namespace" width="30" name="namespace" value={this.state.FormData.namespace} onChange={this.handleChange}/>
                                    <PD.Input label="Default Prefix" width="10" name="prefix" value={this.state.FormData.prefix} onChange={this.handleChange}/>

                                    <PD.Editor label='Proposals' name="proposals" value={this.state.FormData.proposals} onChange={this.handleChange}/>

                                    <PD.Select label="Status" name='status' onChange={this.handleChange} value={this.state.FormData.status}>
                                        {
                                            this.dsd.config.ComponentStatuses.map(
                                                (status, posStatus) =>
                                                    <option key={posStatus} value={status}>{status}</option>
                                            )
                                        }
                                    </PD.Select>

                                    {(() => {
                                        switch (this.state.renderState) {
                                            case 'updating':
                                                return (
                                                    <div>
                                                        <PD.Button disabled={true} type="submit" name="btnSave">
                                                            <Buffering/>
                                                        </PD.Button>
                                                    </div>
                                                )
                                            default:
                                                return (
                                                    <div>
                                                        <PD.Button type="submit" onClick={this.handleSubmit} name="btnSave" value="Save" />
                                                        <PD.Button type="warning" onClick={this.handleSubmit} name="btnCancel" value="Cancel" />
                                                    </div>
                                                )
                                        }
                                    })()}

                                </form>
                            </div>
                        );
                }
                break;

            case 'view':
            default:

                switch (this.state.renderState){
                    case 'loaded':
                        return (
                            <div>
                                <PD.Heading>Code List: {this.state.CodeList.name}</PD.Heading>

                                {this.state.OfferEdit &&
                                    <span style={{paddingRight:10}}>
                                        <PD.Button onClick={this.handleMode} type="submit" value="edit" />
                                    </span>
                                }

                                <ViewCodeList CodeList={this.state.CodeList}/>

                                <br/>

                                <PD.Tabs>

                                    <div label={<span>Items({this.state.countItems === null ? <Buffering/> : this.state.countItems})</span>} data-forcerender="true">
                                        <div style={{display:"flex"}}>
                                            {this.state.OfferEdit &&
                                                <PD.Button name='btnAddItem' value='add a new Item' onClick={this.handleButton}/>
                                            }
                                            <fieldset style={{display:"flex"}}>
                                                <legend>filters</legend>
                                                <PD.Select label='status' name='status' onChange={this.handleItemFilters} value={this.state.ItemFilters.status}>
                                                    {
                                                        this.dsd.config.ItemStatuses.map(
                                                            (status, posStatus) =>
                                                                {
                                                                    return(
                                                                        <option key={posStatus} value={status}>{status}</option>
                                                                    )
                                                                }
                                                        )
                                                    }
                                                </PD.Select>
                                                <PD.Input label="Search" width="15" name="search" value={this.state.ItemFilters.search} onChange={this.handleItemFilters}/>
                                            </fieldset>
                                        </div>
                                        <ListItems filters={{idCodeList:this.state.idCodeList, ...this.state.ItemFilters}} onLoad={this.loadedItems}/>
                                    </div>

                                    <div label={<span>Tree({this.state.countTree === null ? <Buffering/> : this.state.countTree})</span>} data-forcerender="true">
                                        <TreeCodeList idCodeList={this.state.idCodeList} onLoad={this.loadedTree}/>
                                    </div>

                                    <div label='Metadata'>
                                        <ViewMetadata Data={this.state.CodeList} />
                                    </div>

                                    <div label={<span>Versions({this.state.countVersions === null ? <Buffering/> : this.state.countVersions})</span>}  data-forcerender="true">
                                        {this.versions()}
                                    </div>
                                    
                                    <div label='Developer'>
                                        <Rendition
                                            endpoint="/codelists"
                                            id={this.state.idCodeList}
                                        />
                                    </div>

                                </PD.Tabs>

                            </div>
                        )
                }
        };

        return <div />;
    };
}

export default function CodeList_wrapper(props) {
    const navigation = useNavigate();
    const location  = useLocation();
    const params    = useParams();
    return <CodeList {...props} navigation={navigation} location={location} params={params} />;
}
